module.exports = __webpack_public_path__ + "img/NAxeman64_ua.f48cb925.webp";